import { useState } from 'react';

/**
 * Hold the last idle value while {@link busy} so store updates cannot reflow UI.
 */
export const useFrozenWhileBusy = <T>(liveValue: T, busy: boolean): T => {
  const [frozenValue, setFrozenValue] = useState(liveValue);
  if (!busy && frozenValue !== liveValue) {
    setFrozenValue(liveValue);
  }
  return busy ? frozenValue : liveValue;
};
